import { render, staticRenderFns } from "./WatercolumnWidget.vue?vue&type=template&id=706669de&scoped=true"
import script from "./WatercolumnWidget.vue?vue&type=script&lang=js"
export * from "./WatercolumnWidget.vue?vue&type=script&lang=js"
import style0 from "./WatercolumnWidget.vue?vue&type=style&index=0&id=706669de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706669de",
  null
  
)

export default component.exports